import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { Contract } from 'src/app/models/entities/contract';
import { ContractService } from 'src/app/services/contract.service';
import * as FileSaver from 'file-saver';
import { formatDate } from '@angular/common';
import { VContract } from 'src/app/models/entities/v-contract';


@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  destroy$ = new Subject<void>();
  deleteModal: boolean;
  contractId: number;
  contracts$: Observable<Contract[]>;
  exportDatas: any[] = [];
  loading: boolean;

  @ViewChild('dt', { static: false }) dt: any;
  constructor(private contractService: ContractService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.loading = true;
    this.contracts$ = this.contractService.getList().pipe(map(result => result.data), finalize(() => this.loading = false));
    this.contractService.getList().pipe(takeUntil(this.destroy$)).subscribe(result => {
      for (let value of result.data) {
        this.exportDatas.push(
          {
            "Abone No": value.contractNumber,
            "Servis Kodu": value.serviceCode,
            "Platform Adı": value.portalName,
            "Müşteri Kodu": value.customerCode,
            "Müşteri Adı": value.customerName,
            "Proje Adı": value.projectName,
            "Hizmet": value.serviceName,
            "Abonelik Tipi": value.contractTypeName,
            "Birim Fiyat": value.serviceUnitPrice,
            "Komisyon Bedeli": value.commissionPrice,
            "Para Birimi": value.currencyUnit,
            "Başlangıc Tarihi": value.startDate,
            "Bitiş Tarihi": value.endDate,
            "Fatura Tarihi": value.invoiceDate,
            "Notlar": value.notes,
            "Bayi Adı": value.dealerName,
            "Şehir": value.reportTag3,
            "Terminal Sayısı": value.numberOfTerminals
          }
        )
      }
    })
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }


  showDeleteModal(contractId: number) {
    this.deleteModal = true;
    this.contractId = contractId;
  }

  deleteContract() {
    this.deleteModal = false;
    this.contractService.delete(this.contractId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportDatas)
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Abonelikler");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + ' ' + formatDate(new Date, 'dd-MM-yyyy', 'en') + EXCEL_EXTENSION);
  }

}
